/* "Make it theirs" engraving demo: shoppers type one or two lines and see them engraved on a real piece.
   Text is sized to fit and clipped to each piece's engravable area (traced from its 900px product photo),
   limits come from the product's engraving settings, and fonts are the store's own engraving fonts.
   Builds only when the section is near the screen; without JS the original photo stays. */
(function () {
  var host = document.querySelector('#fv2 .eng-demo');
  if (!host || !window.IntersectionObserver || !document.createElementNS) { return; }
  var NS = 'http://www.w3.org/2000/svg';
  var TAG_EDGE_INSET = 3, TAG_BLOCK_FRAC = 0.55, TAG_LINE_GAP = 1.05;
  var PIECES = {
    tag: { label: 'Dog tag', img: host.getAttribute('data-tag-img'), url: host.getAttribute('data-tag-url'), maxChars: +host.getAttribute('data-tag-max') || 40,
      mirror: true, area: { type: 'edge', x: 432, y: 404, w: 146, h: 356 }, maxSize: 64, minSize: 22, fill: 'rgba(34,32,30,.88)' },
    signet: { label: 'Signet ring', img: host.getAttribute('data-signet-img'), url: host.getAttribute('data-signet-url'), maxChars: +host.getAttribute('data-signet-max') || 15,
      mirror: false, area: { type: 'ellipse', cx: 452, cy: 565, rx: 150, ry: 137 }, maxSize: 150, minSize: 34, fill: 'rgba(52,50,48,.74)' }
  };
  // Same fonts and order as the product page list in snippets/engraving-config.liquid; the spacing and capH tune each one for this preview.
  var FONTS = [
    { key: 'mont', family: 'Engrave Montserrat', label: 'Montserrat', spacing: 0.06, capH: 0.36 },
    { key: 'handwriting', family: 'Engrave Handwriting', label: 'Handwriting', spacing: 0, capH: 0.42 },
    { key: 'allura', family: 'Engrave Allura', label: 'Allura', spacing: 0, capH: 0.42 },
    { key: 'oldenglish', family: 'Engrave Old English', label: 'Old English', spacing: 0, capH: 0.4 },
    { key: 'lemonmilk', family: 'Engrave LEMON MILK', label: 'LEMON MILK', spacing: 0.04, capH: 0.36 },
    { key: 'notosans', family: 'Engrave Noto Sans', label: 'Noto Sans', spacing: 0.02, capH: 0.36 }
  ];
  var LINE_H = 1.15;
  var st = { piece: 'tag', font: 'mont', lines: 2 };

  function el(tag, attrs, parent, ns) {
    var e = ns ? document.createElementNS(NS, tag) : document.createElement(tag);
    for (var k in attrs) { if (k === 'text') { e.textContent = attrs[k]; } else { e.setAttribute(k, attrs[k]); } }
    if (parent) { parent.appendChild(e); }
    return e;
  }
  function fontByKey(k) { for (var i = 0; i < FONTS.length; i++) { if (FONTS[i].key === k) { return FONTS[i]; } } return FONTS[0]; }
  function areaPath(a) {
    return a.type === 'ellipse'
      ? 'M' + (a.cx - a.rx) + ',' + a.cy + ' a' + a.rx + ',' + a.ry + ' 0 1,0 ' + (a.rx * 2) + ',0 a' + a.rx + ',' + a.ry + ' 0 1,0 ' + (-a.rx * 2) + ',0 Z'
      : 'M' + a.x + ',' + a.y + ' h' + a.w + ' v' + a.h + ' h' + (-a.w) + ' Z';
  }

  // Offer only fonts the page actually declares (snippets/engraving-fonts.liquid), so a font the store drops never shows a fallback face here.
  function declared(family) {
    var found = false;
    document.fonts.forEach(function (f) { if (f.family.replace(/["']/g, '') === family) { found = true; } });
    return found;
  }

  function build() {
    if (document.fonts && document.fonts.forEach) {
      var offered = FONTS.filter(function (f) { return declared(f.family); });
      if (offered.length) { FONTS = offered; }
    }
    host.classList.add('is-live');
    host.innerHTML = '';
    var stage = el('div', { 'class': 'eng-demo__stage' }, host);
    var svg = el('svg', { viewBox: '0 0 900 900', role: 'img', 'aria-label': 'Engraving preview' }, stage, true);
    var clip = el('clipPath', { id: 'engDemoClip' }, el('defs', {}, svg, true), true);
    var clipPath = el('path', { d: '' }, clip, true);
    var img = el('image', { x: 0, y: 0, width: 900, height: 900 }, svg, true);
    var group = el('g', {}, el('g', { 'clip-path': 'url(#engDemoClip)' }, svg, true), true);
    var measure = el('text', { x: -9999, y: -9999, 'font-size': 100, opacity: 0 }, svg, true);

    var ctrl = el('div', { 'class': 'eng-demo__ctrl' });
    var copyCol = host.parentNode && host.parentNode.querySelector('.copy'), ctaRow = copyCol && copyCol.querySelector('.cta-row');
    if (copyCol && ctaRow) { copyCol.insertBefore(ctrl, ctaRow); } else { host.appendChild(ctrl); }
    var pieceRow = el('div', { 'class': 'eng-demo__row', role: 'group', 'aria-label': 'Piece' }, ctrl);
    var lineRow = el('div', { 'class': 'eng-demo__row', role: 'group', 'aria-label': 'Lines' }, ctrl);
    function chip(row, text, onClick) { var b = el('button', { type: 'button', 'class': 'eng-demo__chip', text: text }, row); b.addEventListener('click', onClick); return b; }
    var pieceBtns = Object.keys(PIECES).map(function (k) { var b = chip(pieceRow, PIECES[k].label, function () { st.piece = k; render(); }); b.dataset.k = k; return b; });
    var lineBtns = [1, 2].map(function (n) { var b = chip(lineRow, n === 1 ? 'One line' : 'Two lines', function () { st.lines = n; render(); }); b.dataset.k = String(n); return b; });
    var in1 = el('input', { type: 'text', 'class': 'eng-demo__input', value: 'J.M.', 'aria-label': 'Line 1', autocomplete: 'off', spellcheck: 'false' }, ctrl);
    var in2 = el('input', { type: 'text', 'class': 'eng-demo__input', value: '21.10.26', 'aria-label': 'Line 2', autocomplete: 'off', spellcheck: 'false' }, ctrl);
    var sel = el('select', { 'class': 'eng-demo__select', 'aria-label': 'Font' }, ctrl);
    FONTS.forEach(function (f) { el('option', { value: f.key, text: f.label }, sel); });
    sel.value = st.font;
    var status = el('p', { 'class': 'eng-demo__status', role: 'status' }, ctrl);
    var link = el('a', { 'class': 'eng-demo__link', href: '#', text: 'Engrave this piece →' }, ctrl);
    in1.addEventListener('input', render); in2.addEventListener('input', render);
    sel.addEventListener('change', function () { st.font = sel.value; loadFont(); render(); });

    function w100(text, f) {
      measure.setAttribute('font-family', '"' + f.family + '"'); measure.setAttribute('letter-spacing', f.spacing * 100); measure.textContent = text || ' ';
      return measure.getComputedTextLength() || 1;
    }
    function fit(lines, p, f) {
      var ws = lines.map(function (t) { return w100(t, f); }), n = lines.length, a = p.area;
      if (a.type === 'ellipse') {
        for (var s = p.maxSize; s >= 6; s--) {
          var gap = s * LINE_H, top = -gap * (n - 1) / 2, ok = true;
          for (var i = 0; i < n; i++) {
            var far = Math.abs(top + i * gap) + s * f.capH;
            if (far >= a.ry || ws[i] * s / 100 > 2 * a.rx * Math.sqrt(1 - Math.pow(far / a.ry, 2)) * 0.92) { ok = false; break; }
          }
          if (ok) { return s; }
        }
        return 6;
      }
      return Math.min(p.maxSize, (a.h * 0.9) / (Math.max.apply(null, ws) / 100), (a.w * TAG_BLOCK_FRAC) / (n * TAG_LINE_GAP));
    }
    function render() {
      var p = PIECES[st.piece], f = fontByKey(st.font), two = st.lines === 2;
      pieceBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.k === st.piece)); });
      lineBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.k === st.lines)); });
      in2.hidden = !two;
      var clean = function (s) { return s.replace(/[\r\n]+/g, ' ').replace(/\s{2,}/g, ' '); };
      var a1 = clean(in1.value), a2 = two ? clean(in2.value) : '';
      if (a1.length > p.maxChars) { a1 = a1.slice(0, p.maxChars); in1.value = a1; }
      if (a1.length + a2.length > p.maxChars) { a2 = a2.slice(0, Math.max(0, p.maxChars - a1.length)); in2.value = a2; }
      var lines = [a1.trim()].concat(two ? [a2.trim()] : []).filter(Boolean);
      img.setAttribute('href', p.img);
      img.setAttribute('transform', p.mirror ? 'translate(900 0) scale(-1 1)' : '');
      clipPath.setAttribute('d', areaPath(p.area));
      link.setAttribute('href', p.url);
      while (group.firstChild) { group.removeChild(group.firstChild); }
      if (!lines.length) { status.textContent = 'Type something to see it engraved.'; return; }
      var s = fit(lines, p, f), n = lines.length, gap = s * (p.area.type === 'edge' ? TAG_LINE_GAP : LINE_H);
      var place;
      if (p.area.type === 'ellipse') {
        var A = p.area, top = A.cy - gap * (n - 1) / 2;
        place = function (i) { return { x: A.cx, y: top + i * gap, tf: 'translate(' + A.cx + ' ' + A.cy + ') scale(1 .96) translate(' + (-A.cx) + ' ' + (-A.cy) + ')' }; };
      } else {
        // Runs along the tag, centred on the face, reading bottom to top, block hugging the outer edge.
        var B = p.area, cy = B.y + B.h / 2, edgeX = B.x + B.w - TAG_EDGE_INSET - gap / 2;
        place = function (i) { var x = edgeX - (n - 1 - i) * gap; return { x: x, y: cy, tf: 'rotate(-90 ' + x + ' ' + cy + ')' }; };
      }
      lines.forEach(function (t, i) {
        var q = place(i), base = { 'font-family': '"' + f.family + '"', 'font-size': s.toFixed(1), 'letter-spacing': (f.spacing * s).toFixed(2), 'text-anchor': 'middle', 'dominant-baseline': 'central', transform: q.tf };
        var hi = {}, main = {}, k;
        for (k in base) { hi[k] = base[k]; main[k] = base[k]; }
        hi.x = q.x; hi.y = q.y + 1.4; hi.fill = 'rgba(255,255,255,.7)'; hi.text = t;
        main.x = q.x; main.y = q.y; main.fill = p.fill; main.text = t; main['data-main'] = '1';
        el('text', hi, group, true); el('text', main, group, true);
      });
      var used = a1.length + a2.length;
      status.textContent = s < p.minSize ? 'Too long to read clearly on this piece. Try fewer characters.'
        : used >= p.maxChars ? 'That\'s the ' + p.maxChars + '-character limit for this piece.'
        : used + ' / ' + p.maxChars + ' characters';
    }
    function loadFont() { if (document.fonts && document.fonts.load) { document.fonts.load('100px "' + fontByKey(st.font).family + '"').then(render, render); } }
    render();
    loadFont();
  }

  // Build only when the section approaches the screen, so the engraving fonts never load for people who don't scroll there.
  var io = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) { io.disconnect(); build(); }
  }, { rootMargin: '300px 0px' });
  io.observe(host);
})();
